fourToldApp.controller("recoverPasswordCntrl", function($scope, $localStorage, services, $window, $location, $mdToast, $mdDialog, countryCode, countries, theme) {
  $scope.forgotPassword = new Object(); 
  var activeDiv = document.querySelector('html');
  $scope.theme = JSON.parse($window.sessionStorage.getItem("theme"));
  $scope.progressCircular = true;
  $scope.dial_codes = countries;
  $scope.theme = theme.getTheme();
  $localStorage.$reset();
  countryCode.dialCode(false, theme.getTheme())
      .then(function (result) {
      	 console.log(result);
          $scope.progressCircular = false;
          $scope.dialCode = result;
      })
      .catch(function (message) {
          console.log(message);
          $scope.progressCircular = false;
          $scope.showAlert('Debe activar los permisos de ubicación');
      });
      function DialogController($scope, $mdDialog, items) {
        $scope.items = items;
        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.answer = function(answer) {
            $mdDialog.hide(answer);
        };
      }
      $scope.dialogTag = function(data, fromRegister) {
        $mdDialog.show({
                controller: DialogController,
                locals: {
                    items: data
                },
                templateUrl: '../views/pages/tags.html',
                parent: angular.element(document.body)
            })
            .then(function(tag) {
                if (tag) {                            
                    $scope.forgotPassword.phoneNumber = $scope.forgotPassword.phoneNumber + "|" + tag;
                    console.log(tag)
                    $scope.passwordRecover()
                }
            }, function(cancel) {});
    };
    $scope.recoverPassword = function() {
        $scope.forgotPassword.phoneNumber = $scope.dialCode + $scope.phoneNumber;
        if($location.search().tag!=null && $location.search().tag!='undefined') {
            var tag = $location.search().tag
            var numeroTelf = $scope.forgotPassword.phoneNumber;     
            if(tag) {
                numeroTelf = numeroTelf + "|" + tag;
            }
            $scope.forgotPassword.phoneNumber = numeroTelf;
            $scope.passwordRecover()
        }
        else if ($scope.forgotPassword.phoneNumber) {
            var numeroTelf = $scope.forgotPassword.phoneNumber;  
            var data = {userName: numeroTelf}
            services.userTags().getTags(data,
                function(response) {
                    console.log(response.data)
                    var tags = response.data;
                    if(tags.length == 0) {
                        $scope.passwordRecover()
                    } else if(tags.length == 1) {
                        var tag = tags[0]
                        $scope.forgotPassword.phoneNumber = $scope.forgotPassword.phoneNumber + "|" + tag.id;
                        $scope.passwordRecover()
                    } else {
                        // is a list
                        $scope.dialogTag(tags)
                    }
                },
                function error(response) {console.log("error getTag")});
        }
    }
      

  $scope.passwordRecover = function() { 
      if ($scope.forgotPassword.phoneNumber) {
          $scope.progressEdit = "ok";
          $scope.forgotPassword.type = $scope.sendType;
          services.recover_password.password({}, $scope.forgotPassword, function(status) {
              $scope.progressEdit = undefined;
              if (status.code !== -2) {
                  window.sessionStorage.setItem('phoneNumber',  $scope.forgotPassword.phoneNumber); 
                  $location.path("/password-recovery");
              }
          }, function err() {
              $scope.progressEdit = undefined;
              $scope.dialog('Número telefónico incorrecto o Error en el formato telefónico.', 'error-toast');
              $scope.loginError = true;
          });
      }
  }

  $scope.showAlert = function(message) {
      $mdDialog.show(
          $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Notificación')
          .textContent(message)
          .ariaLabel('Alert Dialog Demo')
          .ok('Ok')
      );
  };

  $scope.login = function() {
    $location.path('/');
  };
});
